import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'group'

const GroupModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default GroupModule



// WEBPACK FOOTER //
// ./src/store/module/group/index.js